import  Claim  from "./claim";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "claim",
  childRoutes: [
    { path: "claim", component: Claim, isIndex: true },
  ],
};
